import { Route, Switch } from "react-router-dom";
import { AppRouteUi } from "../../../config/appRoute";
import { PageInvoiceList } from "./PageInvoiceList";
import { PagePaymentMethod } from "./PagePaymentMethod";
import { PageViewInvoice } from "./PageViewInvoice";

export function PageBilling() {
  return (
    <Switch>
      <Route
        path={AppRouteUi.Billing.PaymentMethod()}
        component={PagePaymentMethod}
        exact
      />
      <Route
        path={AppRouteUi.Billing.Invoice()}
        component={PageInvoiceList}
        exact
      />
      <Route
        path={AppRouteUi.Billing.ViewInvoice(":id")}
        component={PageViewInvoice}
        exact
      />
    </Switch>
  );
}
